<!doctype html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <link rel="icon" type="image/png" href="/assets/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="manifest" href="/manifest.json" />
        <title>Asurion Workspace</title>
    </head>
    <body>
        <div id="root"></div>
        <script type="module" src="./src/Main.tsx"></script>
    </body>
</html>
